import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { TopnavComponent } from '@/core/components/topnav/topnav.component';
import { HorizontalTopnavComponent } from '@/core/components/horizontal-topnav/horizontal-topnav.component';
import { SidenavComponent } from '@/core/components/sidenav/sidenav.component';
import { RightConfigComponent } from '@/core/components/right-config/right-config.component';
import { NavegacaoService } from '@/core/services/navegacao/navegacao.service';
import { TemaService } from '@/core/services/tema/tema.service';
import { UsuarioLogadoService } from '@/core/services/usuarioLogado/usuario-logado.service';
import { ButtonComponent } from '@/shared/components/ui/button';
import { NotificacaoComponent } from '@/shared/components/ui/notificacao/notificacao.component';
import { Version } from '@/pages/versionamento/database/version';

@Component({
  selector: 'app-main',
  standalone: true,
  imports: [
    RouterModule,
    TopnavComponent,
    HorizontalTopnavComponent,
    SidenavComponent,
    RightConfigComponent,
    NotificacaoComponent,
    ButtonComponent,
  ],
  templateUrl: './main.component.html',
})
export class MainLayoutComponent {
  urlApp = '';

  version = new Version();

  notificacao = {
    titulo: null,
    mensagem: null,
    mostrar: false,
  };

  protected readonly navegacao = inject(NavegacaoService);
  protected readonly tema = inject(TemaService);

  private readonly router = inject(Router);
  private readonly _usuario = inject(UsuarioLogadoService);

  constructor() {
    this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        takeUntilDestroyed()
      )
      .subscribe((e) => {
        if (e.url === '/' || e.url === '/login') {
          this.router.navigate(['/dashboard']);
        }
      });
  }

  ngOnInit(): void {
    const token = this._usuario.obterUsuarioLogado().userToken;
    this.tema.carregar(token.id);
    this.navegacao.carregar(token.id, token.email);

    this._checkVersaoLogin();

    if (environment.production) {
      this.urlApp = 'https://app.rematefy.com/';
    } else {
      this.urlApp = 'https://app-hml.rematefy.com/#/dashboard';
    }
  }

  _checkVersaoLogin() {
    const USER_ID = this._usuario.obterUsuarioLogado().userToken.id;
    let notificar = false;

    let lastLogin = localStorage.getItem(`vl_${USER_ID}`);

    if (lastLogin !== null && lastLogin !== '') {
      if (lastLogin !== this.version.versao.atual) {
        if (this.version.versao.mostrar) notificar = true;
      }
    } else {
      if (this.version.versao.mostrar) notificar = true;
    }

    if (notificar) {
      this.notificacao.titulo = this.version.versao.title;
      this.notificacao.mostrar = true;
      this.notificacao.mensagem = '<h5> Veja as Novidades: </h5> <ul>';

      this.version.versao.itens.forEach((item) => {
        this.notificacao.mensagem += `<li> <h6> ${item} </h6> </li>`;
      });

      this.notificacao.mensagem += '</ul>';
    }

    if (!notificar) {
      this._setVersaoLogin(USER_ID, this.version.versao.atual);
    }
  }

  _setVersaoLogin(USER_ID, versao) {
    localStorage.setItem(`vl_${USER_ID}`, versao);
  }

  fechar() {
    const USER_ID = this._usuario.obterUsuarioLogado().userToken.id;
    this._setVersaoLogin(USER_ID, this.version.versao.atual);

    this.notificacao.mostrar = false;
  }
}
